
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const AdmissionsPage = lazy(() => import('../pages/admissions/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const LocationPage = lazy(() => import('../pages/location/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const RehabKenyaPage = lazy(() => import('../pages/rehab-kenya/page'));
const RehabRuiruPage = lazy(() => import('../pages/rehab-ruiru/page'));
const RehabNearNairobiPage = lazy(() => import('../pages/rehab-near-nairobi/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ResourcePage = lazy(() => import('../pages/resource/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:slug',
    element: <ServicePage />,
  },
  {
    path: '/admissions',
    element: <AdmissionsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/location',
    element: <LocationPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/rehabilitation-centre-kenya',
    element: <RehabKenyaPage />,
  },
  {
    path: '/rehabilitation-centre-ruiru',
    element: <RehabRuiruPage />,
  },
  {
    path: '/rehabilitation-centre-near-nairobi',
    element: <RehabNearNairobiPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/resources/:slug',
    element: <ResourcePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
